import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { shouldShowCarRentalInformation } from '@/scopes/products/domain/policies/brand'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export function CarRental() {
  const brandName = useConfiguration('brandName')
  const intl = useIntl()

  if (!shouldShowCarRentalInformation(brandName)) {
    return null
  }

  return (
    <Item elementDL="Car Rental" title={intl.formatMessage({ id: 'practical_info_car_rental_title' })} Glyph="CarRight">
      <RichText innerHTML={intl.formatMessage({ id: 'practical_info_car_rental_content' })} />
    </Item>
  )
}
